module.exports = __webpack_public_path__ + "static/media/Sobre-Sendero.fe86d9a6.jpg";